/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Altersteilzeitaktiv2Inputs */



/**

* @param {_Class_Altersteilzeitaktiv2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_altersteilzeitaktiv2 = /** @type {((inputs?: _Class_Altersteilzeitaktiv2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Altersteilzeitaktiv2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Altersteilzeit Aktiv")
});
export { _class_altersteilzeitaktiv2 as "_class_AltersteilzeitAktiv" }